import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LOCAL_STORAGE_KEYS } from "src/app/shared/constants/storage-keys";

@Component({
  selector: "tdms-year-card",
  template: `
    <button
      type="button"
      class="year-card"
      [class.selected]="isSelected"
      [attr.aria-pressed]="isSelected"
      (click)="toggleSelection()"
      [attr.aria-label]="getAriaLabel()"
    >
      {{ yearLabel }}
      <span *ngIf="yearLabel === 1">Year</span>
      <span *ngIf="yearLabel !== 1">Years</span>
    </button>
  `,
  styleUrls: ["./date-facet.component.scss"],
  standalone: false,
})
export class YearCardComponent implements OnInit {
  @Input() yearLabel = 0;
  @Input() isSelected = false;
  @Output() selectionChanged = new EventEmitter<boolean>();

  ngOnInit() {
    const selectedYear = localStorage.getItem(LOCAL_STORAGE_KEYS.YEAR_CARD_SEL);
    this.isSelected = selectedYear !== null && Number.parseInt(selectedYear, 10) === this.yearLabel;
  }

  getAriaLabel(): string {
    return `${this.yearLabel} ${this.yearLabel === 1 ? "year" : "years"}`;
  }

  toggleSelection() {
    this.isSelected = !this.isSelected;
    this.selectionChanged.emit(this.isSelected);
  }
}
